import { Button, Tag, Flex, FormControl, FormErrorMessage, FormLabel, Heading, Input, Link, Select, Box } from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import PerfilAcessoService from "../../../main/services/PerfilAcessoService";
import { Link as ReactLink, useHistory } from 'react-router-dom';
import SemRegistros from '../../components/SemRegistros';
import { useAuthProvider } from '../../../Context/AuthProvider';
import { criancaFunc } from '../../../helpers/Funcionalidades';
import { Group } from '../Criancas/Group';

const CadastrarPerfilAcesso = () => {

    document.title = 'MCA - Perfis de Acesso - Cadastrar'
    let history = useHistory();

    const { roleKeycloack } = useAuthProvider();
    const [descricaoCount, setDescricaoCount] = useState(0);
    const [tiposOrgao, setTiposOrgao] = useState([]);

    useEffect(() => {
        PerfilAcessoService.listarTiposOrgao()
            .then(res => {
                setTiposOrgao(res.data);
            })
            .catch(() => {})
    }, [])

    const validate = (values) => {
        const errors = {};
        if (!values.descricao || values.descricao === "") {
            errors.descricao = "Nome do Perfil é obrigatório!";
        }
        return errors;
    };

    return roleKeycloack && roleKeycloack.includes(criancaFunc.visualizarTudo) ? (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex flexDir="row" justifyContent="space-between">
                <Heading fontSize="large">
                    Cadastrar Perfil de Acesso
                </Heading>
                <Link as={ReactLink} to="/perfil-acesso/lista" _hover={{ textDecoration: "none" }}>
                    <Button colorScheme={"teal"} px={16}>
                        Voltar
                    </Button>
                </Link>
            </Flex>

            <Formik
                validate={validate}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{ descricao: "", tipoOrgaoId: "", tipoOrgao: "" }}
                onSubmit={(values, { setSubmitting, setFieldError }) => {
                    setTimeout(() => {
                        PerfilAcessoService.novoPerfilAcesso(values).then((res) => {
                            Swal.fire({
                                title: 'Sucesso!',
                                text: 'Registro cadastrado com sucesso!',
                                icon: 'success',
                                confirmButtonText: 'Continuar',
                                confirmButtonColor: '#169499'
                            }).then(function () {
                                history.push("/perfil-acesso/" + res.data.id)
                            });
                            setSubmitting(false);
                        }).catch((error) => {
                            setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                            setSubmitting(false);
                        })
                    }, 200)
                }}>
                {(props) => (
                    <Flex flexDir="column" mt={5}>
                        <Form>
                            <Flex>
                                <Group bgColor="#fff" title="" py="12px">
                                    <Box width={{ lg: '50%' }}>
                                        <Field name="descricao">
                                            {({ field, form }) => (
                                                <FormControl isInvalid={form.errors.descricao && form.touched.descricao}>
                                                    <FormLabel htmlFor="descricao">Nome do Perfil*</FormLabel>
                                                    <Input
                                                        h="42px"
                                                        autoFocus
                                                        backgroundColor="white"
                                                        {...field}
                                                        id="descricao"
                                                        placeholder="Informe o Nome do Perfil de Acesso"
                                                        maxLength={255}
                                                        onChange={(e) => {
                                                            setDescricaoCount(e.target.value.length);
                                                            form.setFieldValue(field.name, e.target.value);
                                                        }}
                                                    />
                                                    <FormErrorMessage>{form.errors.descricao}</FormErrorMessage>
                                                </FormControl>
                                            )}
                                        </Field>

                                        <Flex flexDirection="row-reverse">
                                            <Tag maxW="max-content">{`${descricaoCount}/255`}</Tag>
                                        </Flex>

                                        <Flex mt={5}>
                                            <Field name="tipoOrgaoId">
                                                {({ field, form }) => (
                                                    <FormControl isInvalid={form.errors.tipoOrgaoId}>
                                                        <FormLabel htmlFor="tipoOrgaoId">Tipo de Órgão</FormLabel>
                                                        <Select
                                                            {...field}
                                                            id="tipoOrgaoId"
                                                            backgroundColor={"white"}
                                                            placeholder={"Selecione o Tipo de Órgão"}
                                                            h="42px"
                                                            onChange={(e) => {
                                                                const selected = tiposOrgao.find(t => String(t.id) === e.target.value);
                                                                form.setFieldValue('tipoOrgaoId', e.target.value);
                                                                form.setFieldValue('tipoOrgao', selected ? selected.nome : '');
                                                            }}
                                                        >
                                                            {tiposOrgao.map((tipo) => (
                                                                <option key={tipo.id} value={tipo.id}>
                                                                    {tipo.nome}
                                                                </option>
                                                            ))}
                                                        </Select>
                                                        <FormErrorMessage>{form.errors.tipoOrgaoId}</FormErrorMessage>
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </Flex>

                                    </Box>
                                </Group>
                            </Flex>

                            <Flex mt={2} justifyContent="space-between">
                                <Flex></Flex>
                                <Button
                                    mt={4}
                                    colorScheme="teal"
                                    px={16}
                                    isLoading={props.isSubmitting}
                                    type="submit"
                                    translate="no">
                                    Salvar
                                </Button>
                            </Flex>
                        </Form>
                    </Flex>
                )}
            </Formik>
        </Flex>
    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    )
}

export default CadastrarPerfilAcesso;
